module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.9cfc8815.woff";